import analytics from '@utils/analytics';
import BaseComponent from '../base/baseComponent';
export default class headerHelper extends BaseComponent {
    constructor(element) {
        super(element);
        this.handleHeaderScroll();
        this.handleAnalytics();
        this.scrollDetect();
    }
    get SELECTORS() {
        return {
            menuItem: '.menu-item',
            menuHeading: '.menu-heading',
            hasSubmenu: '.menu-heading',
            thirdLevelLinks: '.submenu-item',
            visualNavigationCard: '.visual-card',
        };
    }
    get CLASSES() {
        return {
            scrolled: 'scrolled',
        };
    }
    handleAnalytics() {
        this.menuItems = this.$el.querySelectorAll(this.SELECTORS.menuItem);
        this.menuItems.forEach((el) => {
            const submenus = el.querySelectorAll('.submenu-group');
            if (submenus.length) {
                submenus.forEach((submenu) => {
                    const secondLevelText = submenu.querySelector('.submenu-heading');
                    const secondLevelLink = secondLevelText ? secondLevelText.querySelector('a') : undefined;
                    if (secondLevelLink) {
                        this.$on('click', (e) => {
                            const firstLevel = el.querySelector(this.SELECTORS.hasSubmenu);
                            const secondLevel = submenu.querySelector('button');
                            analytics.secondLevelClick(firstLevel.dataset.gtmEvent, secondLevel.dataset.gtmEvent);
                        }, secondLevelLink);
                    }
                    const thirdLevelLinks = submenu.querySelectorAll(this.SELECTORS.thirdLevelLinks);
                    if (thirdLevelLinks.length) {
                        thirdLevelLinks.forEach((link) => {
                            this.$on('click', (e) => {
                                const firstLevel = el.querySelector(this.SELECTORS.hasSubmenu);
                                const secondLevel = submenu.querySelector('button');
                                const thirdLevel = e.target;
                                if (submenu.querySelector('button').classList.contains('third-level')) {
                                    const thirdLevelReal = document.querySelector('.third-level');
                                    const secondLevelReal = document.querySelector('.level-column');
                                    analytics.fourthLevelClick(firstLevel.dataset.gtmEvent, secondLevelReal.dataset.gtmEvent, thirdLevelReal.dataset.gtmEvent, thirdLevel.dataset.gtmEvent);
                                }
                                else {
                                    analytics.thirdLevelClick(firstLevel.dataset.gtmEvent, secondLevel.dataset.gtmEvent, thirdLevel.dataset.gtmEvent);
                                }
                            }, link);
                        });
                    }
                });
            }
            // only for visual card links wich are not inside submenu group
            const visualCards = el.querySelectorAll(this.SELECTORS.visualNavigationCard);
            if (visualCards.length) {
                visualCards.forEach((card) => {
                    this.$on('click', (e) => {
                        const firstLevel = el.querySelector(this.SELECTORS.hasSubmenu);
                        analytics.secondLevelClick(firstLevel.dataset.gtmEvent, e.currentTarget.dataset.gtmEvent);
                    }, card);
                });
            }
        });
        this.menuHeadings = this.$el.querySelectorAll(this.SELECTORS.menuHeading);
        // this.menuHeadings.forEach((el: HTMLElement) => {
        // el.addEventListener('mouseenter', () => {
        //   const currentInput = whatInput.ask();
        // https://jira.industries-group.com/browse/OE-7336
        //window.isDesktop() && currentInput == 'mouse' && analytics.firstLevelClick(el.dataset.gtmEvent);
        // });
        // });x
    }
    checkHeaderScrolled(flag) {
        this.$el.classList[flag ? 'add' : 'remove'](this.CLASSES.scrolled);
    }
    handleHeaderScroll() {
        const topPage = document.createElement('div');
        topPage.setAttribute('id', 'top-page');
        document.body.insertBefore(topPage, document.body.childNodes[0]);
        const observer = new IntersectionObserver((entries) => {
            // console.info('checkHeaderScrolled ', entries[0].intersectionRatio);
            this.checkHeaderScrolled(entries[0].intersectionRatio < 1);
        }, { threshold: 1 });
        observer.observe(topPage);
    }
    scrollDetect() {
        let lastScroll = 0;
        document.body.dataset.scroll = 'top';
        window.onscroll = () => {
            let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            // if page is on top add a class to body
            if (currentScroll === 0 || currentScroll < 0) {
                document.body.dataset.scroll = 'top';
            }
            else {
                if (currentScroll > 0 && lastScroll <= currentScroll) {
                    lastScroll = currentScroll;
                    document.body.dataset.scroll = 'down';
                    this.$el.dataset.scroll = 'down';
                }
                else {
                    lastScroll = currentScroll;
                    document.body.dataset.scroll = 'up';
                    this.$el.dataset.scroll = 'up';
                }
            }
        };
    }
}
